import React from 'react';

const AgencyInsuranceTab = ({
  insuranceCompanies,
  selectedCompanies,
  handleCheckboxChange,
  onConfirm,
  onReturn
}) => {
  return (
    <>
      <div className="insurance-checkbox-container insurance-checkbox-container--height">
        {Object.entries(insuranceCompanies).map(([type, inner]) => (
          <div key={type} className="insurance-category">
            <h3 className="category-title">登録{type}名</h3>
            {Object.entries(inner).map(([category, companies]) => (
              <div key={category} className="insurance-category">
                <h4 className="category-title">{category}</h4>
                <div className="insurance-checkbox-grid">
                  {companies.map((company, index) => (
                    <div key={`${category}-${index}`} className="insurance-checkbox-item">
                      <label className="checkbox-native-box">
                        <input
                          type="checkbox"
                          checked={selectedCompanies.includes(company.id)}
                          onChange={() => handleCheckboxChange(company.id)}
                          className="checkbox-native"
                        />
                        {/* companyがオブジェクトの場合は.nameプロパティを使用 */}
                        {typeof company === 'object' ? company.name : company}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="action-buttons c-max-mini c-m-center">
        <button
          type="button"
          className="button button-secondary button-medium"
          onClick={onReturn}
        >
          戻る
        </button>
        <button className="btn btn-primary button-medium" onClick={onConfirm}>申請する</button>
      </div>
    </>
  );
};

export default AgencyInsuranceTab;